export default __webpack_public_path__ + "static/media/co2-label.f0b766d5.png";